<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chiSteinbeckupdate0007#acknow">Acknowledgments</a></p>
<p class="tocf"><a class="xref" href="#/chiSteinbeckupdate0008#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0009#ch01"><b>1</b>  The South Side Scene</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0010#ch02"><b>2</b>  Two Art Ensembles</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0011#ch03"><b>3</b>  The Art Ensemble of Paris</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0012#ch04"><b>4</b>  <i>A Jackson in Your House</i></a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0013#ch05"><b>5</b>  On the Road</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0014#ch06"><b>6</b>  Free Together</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0015#ch07"><b>7</b>  <i>Live at Mandel Hall</i></a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0016#ch08"><b>8</b>  Great Black Music</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0017#ch09"><b>9</b>  <i>Live from the Jazz Showcase</i></a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0018#conc">Conclusion</a></p>
<p class="toc"><a class="xref" href="#/chiSteinbeckupdate0019#gallery">Gallery</a></p>
<p class="tocbmf"><a class="xref" href="#/chiSteinbeckupdate0020#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiSteinbeckupdate0022#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chiSteinbeckupdate0023#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Steinbeck-update-0006.vue?af86ee9c